var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExpand = function SvgExpand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7440777,11.077411 C13.0695146,10.7519741 13.5971521,10.7519741 13.922589,11.077411 C14.2480259,11.4028479 14.2480259,11.9304854 13.922589,12.2559223 L10.5892557,15.5892557 C10.2638187,15.9146926 9.73618126,15.9146926 9.41074435,15.5892557 L6.07741102,12.2559223 C5.75197411,11.9304854 5.75197411,11.4028479 6.07741102,11.077411 C6.40284793,10.7519741 6.93048541,10.7519741 7.25592232,11.077411 L10,13.8214887 L12.7440777,11.077411 Z M10,6.1785113 L7.25592232,8.92258898 C6.93048541,9.24802589 6.40284793,9.24802589 6.07741102,8.92258898 C5.75197411,8.59715207 5.75197411,8.06951459 6.07741102,7.74407768 L9.41074435,4.41074435 C9.73618126,4.08530744 10.2638187,4.08530744 10.5892557,4.41074435 L13.922589,7.74407768 C14.2480259,8.06951459 14.2480259,8.59715207 13.922589,8.92258898 C13.5971521,9.24802589 13.0695146,9.24802589 12.7440777,8.92258898 L10,6.1785113 Z",
    fill: "#777776",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expand.cd7b8a45.svg";
export { ForwardRef as ReactComponent };